import type { FaireProductEntity } from "../../entity_types/product";

export const p_6j9307t64z: FaireProductEntity = {
  token: "p_6j9307t64z",
  type: "product",
  name: "Sriracha (4 Varieties) for Food Service",
  brandToken: "b_7d83bzf5",
  brandName: "Sugar Bob's Finest Kind",
  imageUrl:
    "https://cdn.faire.com/fastly/4924cd59e8fda24e6e515862e56b3e56affcbf2afc29624618af088e79880898.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5bdd7e5c813db44c5e9b34fde701cc6ce10a165115f951e48027b10e8eebe412.png",
    "https://cdn.faire.com/fastly/23dc73c51e08f33c04ddcd2378f7d3f55689d1dd5ec1fe5ed9bd84b3f308d0f7.png",
    "https://cdn.faire.com/fastly/5c724babe25c7ecd4c19c4d6083475cf2aeb67f948dc989679f0e1b5be9a2487.png",
  ],
  priceDollars: 75,
  description:
    "All four varieties of our sriracha - Vermont Maple Sriracha, Jalapeno Maple Sriracha, Habanero Maple Sriracha - are available by the gallon for your restaurant or food manufacturing process. Please note that the picture shown does not go change with each variety.  ",
  tags: [],
  msrpDollars: 150,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:16.648Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
